var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { injectable, inject } from 'inversify';
import { GameConfiguratorSingleton } from './GameConfiguratorSingleton';
import { SERVICE_IDENTIFIER } from '@config/service-identifier';
import { collision } from '@utils/collision';
var BattleServiceImpl = /** @class */ (function () {
    function BattleServiceImpl(defendersService, enemiesService, cartridgesService) {
        this.defendersService = defendersService;
        this.enemiesService = enemiesService;
        this.cartridgesService = cartridgesService;
        this._gameConfigurator = GameConfiguratorSingleton.getInstance();
    }
    BattleServiceImpl.prototype.attackOnDefender = function () {
        var _this = this;
        this.defendersService.defenders.forEach(function (defender, index) {
            _this.enemiesService.enemies.forEach(function (enemy) {
                if (collision(defender, enemy)) {
                    enemy.movement = 0;
                    defender.health = defender.health - enemy.damage;
                    if ((defender === null || defender === void 0 ? void 0 : defender.health) <= 0) {
                        _this.defendersService.removeDefenderByIndex(index);
                        enemy.movement = enemy.speed;
                    }
                }
            });
        });
    };
    BattleServiceImpl.prototype.attackOnEnemy = function () {
        var _this = this;
        this.enemiesService.enemies.forEach(function (enemy, enemyIndex) {
            _this.cartridgesService.cartridges.forEach(function (cartridge, cartridgeIndex) {
                if (collision(enemy, cartridge)) {
                    enemy.health = enemy.health - cartridge.power;
                    _this.cartridgesService.removeCartridgeByIndex(cartridgeIndex);
                    if ((enemy === null || enemy === void 0 ? void 0 : enemy.health) <= 0) {
                        _this._gameConfigurator.balance =
                            _this._gameConfigurator.balance + enemy.reward;
                        _this.enemiesService.removeEnemyByIndex(enemyIndex);
                    }
                }
            });
        });
    };
    BattleServiceImpl.prototype.fight = function () {
        this.attackOnEnemy();
        this.attackOnDefender();
    };
    BattleServiceImpl = __decorate([
        injectable(),
        __param(0, inject(SERVICE_IDENTIFIER.DEFENDERS_SERVICE)),
        __param(1, inject(SERVICE_IDENTIFIER.ENEMIES_SERVICE)),
        __param(2, inject(SERVICE_IDENTIFIER.CARTRIDGES_SERVICE))
    ], BattleServiceImpl);
    return BattleServiceImpl;
}());
export { BattleServiceImpl };
